export default "assets/images/logo-inde-a3516202.png";